import React from "react";
import classNames from "classnames";

export type ButtonSize = "small" | "medium" | "large";
export type ButtonVariant = "primary" | "secondary" | "tertiary";

interface GetBookingButtonClassArgs {
  size?: ButtonSize;
  variant?: ButtonVariant;
  className?: string;
}

export const getBookingButtonClass = ({
  size = "large",
  variant = "primary",
  className = "",
}: GetBookingButtonClassArgs) =>
  classNames("base-booking-button", className, {
    "base-booking-button--primary": variant === "primary",
    "base-booking-button--secondary": variant === "secondary",
    "base-booking-button--tertiary": variant === "tertiary",
    "base-booking-button--small": size === "small",
    "base-booking-button--medium": size === "medium",
    "base-booking-button--large": size === "large",
  });

interface BaseBookingButtonProps {
  label: string;
  description?: string;
  onClick?: () => void;
  disabled?: boolean;
  labelClassName?: string;
  descriptionClassName?: string;
  size?: ButtonSize;
  variant?: ButtonVariant;
  className?: string;
}

export const Button: React.FC<BaseBookingButtonProps> = ({
  label,
  description,
  onClick,
  disabled = false,
  labelClassName = "",
  descriptionClassName = "",
  size = "large",
  variant = "primary",
  className = "",
}) => {
  const buttonClass = getBookingButtonClass({ size, variant, className });

  return (
    <button onClick={onClick} disabled={disabled} className={buttonClass}>
      <div className={labelClassName}>{label}</div>
      {description && <div className={descriptionClassName}>{description}</div>}
    </button>
  );
};
